import React from 'react';
// import Button from 'react-bootstrap/Button';
import Categories from './BbCategories';
// import Player from './BbPlayer';
import './BbBannerShared.css';
import './BbWelcomeBigSpender.css';
// import './BbCountryCode';

class WelcomeBigSpender extends React.Component {
  constructor(props) {
    super(props);
    this.handleCategorySelection = this.handleCategorySelection.bind(this);
  }

  handleCategorySelection(o) {
    this.props.handleCategorySelection(o);
  }

  render() {
    console.log('*** WELCOME BIG SPENDER ***');

    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div className="col center">
            <div id="bb_welcome_big_spender" className="banner_shared">
              Hello
              {' '}
              {this.props.playerInfo.user_login}
              , welcome to your private game room,
              <span className="bb_white_white">
                {' '}
                {this.props.roomName}
              </span>
              !
            </div>
          </div>
        </div>
        <div className="row g-0">
          <div className="col shadow-sm p-3 mb-5 bg-body rounded">
            <Categories
              cats={this.props.cats}
              roomKey={this.props.roomKey}
              roomName={this.props.roomName}
              onCategoriesChildChange={this.handleCategorySelection}
              key="welcomecatkeyprivate"
            />
          </div>
        </div>
        <div className="row g-0">
          <div className="col shadow-sm WelcomeTicketHolder p-3 mb-5 bg-body rounded">
            <div>
              <h5>Public Game Room</h5>
              <p>
                The public game room is always open and waiting for you to
                &nbsp;
                <a
                  href={`/play/?playerid=${this.props.playerInfo.id}&playername=${this.props.playerInfo.user_login}&roomkey=wysisygg&roomname=Room1`}
                >
                  Play!
                </a>
              </p>
            </div>
          </div>
          {/* <div className="col shadow-sm p-3 mb-5 bg-body rounded">
            <Player playerInfo={this.props.playerInfo} key="DoINeedThisKey" />
          </div> */}
        </div>
        {/* <div className="row g-0">
          <div className="col shadow-sm p-3 mb-5 bg-body rounded">
            <Button type="button" className="btn btn-danger">
              This button does not work yet.
            </Button>
          </div>
          <div className="col shadow-sm p-3 mb-5 bg-body rounded">xyz</div>
        </div> */}
      </div>
    );
  }
}
export default WelcomeBigSpender;
